"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const image_1 = __importDefault(require("next/image"));
const prop_types_1 = __importDefault(require("prop-types"));
const next13_enums_environment_1 = require("@gerenciatd/next13.enums.environment");
// si detecto movistar.es/estaticos => prod.cms.col.movistar.es/estaticos y no es prod.cms
const MOVISTAR_STATIC_PATH = "movistar.es/estaticos";
const CDN_DOMAIN = "prod.cms.col.movistar.es";
const COL_10_DOMAIN = "https://col10mgmt.tsm.inet";
const PROXY_STATIC_PATH = "https://prod.cms.col.movistar.es/estaticos";
const NEXT_CDN = `${process.env.NEXT_PUBLIC_CDN}`;
const CURRENT_ENVIRONMENT = `${process.env.NEXT_PUBLIC_ENV_NAME}`;
const ERROR_COLOR = "\x1b[31m%s\x1b[0m";
const checkAbsoluteRoute = (src = "") => {
    return src && (src.indexOf("http") !== -1 || src.indexOf("//") !== -1);
};
const customLoader = (src) => {
    let finalSrc = src;
    const isAbsoluteRoute = checkAbsoluteRoute(src);
    const isLocalImage = finalSrc.indexOf("/public") === 0;
    const isMovistarStatic = src.indexOf(CDN_DOMAIN) === -1 && src.indexOf(MOVISTAR_STATIC_PATH) > -1;
    if (isAbsoluteRoute && isMovistarStatic) {
        finalSrc = finalSrc.replace("https:", "").replace("http:", "");
        finalSrc = finalSrc.replace("//", "").replace("www.", "");
        finalSrc = finalSrc.replace(MOVISTAR_STATIC_PATH, PROXY_STATIC_PATH);
    }
    if (!isAbsoluteRoute) {
        if ((CURRENT_ENVIRONMENT === next13_enums_environment_1.ENV_NAME.DEV ||
            CURRENT_ENVIRONMENT === next13_enums_environment_1.ENV_NAME.QA) &&
            !isLocalImage) {
            finalSrc = `${COL_10_DOMAIN}${finalSrc}`;
        }
        if (isLocalImage) {
            finalSrc = `${NEXT_CDN}${finalSrc}`;
            finalSrc = finalSrc.replace("/public", "");
        }
    }
    return finalSrc.trim();
};
const Imagen = ({ src, srcWebp, alt, fill, width, height, objectFit, objectPosition, className, custoObjectInfo, cyData, priority, }) => {
    const [imageError, setImageError] = (0, react_1.useState)(false);
    const onError = (e) => {
        if (e && e.currentTarget && e.currentTarget.onerror) {
            e.currentTarget.onerror = null;
        }
        // TODO: Check if a default image will be used to assign a new source
        if (!imageError) {
            setImageError(true);
        }
    };
    if (imageError || !src) {
        console.log(ERROR_COLOR, src);
        return react_1.default.createElement("div", { className: `image fallback ${alt}` });
    }
    const objectStyle = {
        objectFit: objectFit ? objectFit : undefined,
        objectPosition: objectPosition ? objectPosition : undefined,
    };
    const editModal = custoObjectInfo &&
        (() => custoObjectInfo.handler(custoObjectInfo.entryPoint));
    if (src && srcWebp)
        return (react_1.default.createElement("picture", null,
            react_1.default.createElement("source", { srcSet: customLoader(srcWebp), type: "image/webp" }),
            react_1.default.createElement(image_1.default, { src: customLoader(src), style: objectStyle, alt: alt, width: width, height: height, fill: fill, unoptimized: true, onClick: editModal, className: `image${objectFit ? ` object-fit--${objectFit}` : ""} ${objectPosition ? ` object-fit--${objectPosition}` : ""} ${className}`, "data-cy": cyData, priority: priority })));
    return (react_1.default.createElement(image_1.default, { src: customLoader(src), style: objectStyle, alt: alt, width: width, height: height, fill: fill, unoptimized: true, onError: onError, onClick: editModal, className: `image${objectFit ? ` object-fit--${objectFit}` : ""} ${objectPosition ? ` object-fit--${objectPosition}` : ""} ${className}`, "data-cy": cyData, priority: priority }));
};
Imagen.propTypes = {
    /**
     * Url de la imagen.
     */
    src: prop_types_1.default.string.isRequired,
    /**
     * Texto alternativo de la imagen.
     */
    alt: prop_types_1.default.string.isRequired,
    /**
     * Ancho en píxeles de la imagen. Obligatorio excepto cuando se especifica la propiedad fill.
     */
    width: prop_types_1.default.oneOfType([prop_types_1.default.number, prop_types_1.default.string]),
    /**
     * Alto en píxeles de la imagen. Obligatorio excepto cuando se especifica la propiedad fill.
     */
    height: prop_types_1.default.oneOfType([prop_types_1.default.number, prop_types_1.default.string]),
    /**
     * Estirará la imagen para ajustarse al contenedor padre en lugar de usar 'width' y 'height'. Cuando es 'true' es OBLIGATORIO asignarle al contenedor padre
     * uno de los siguientes estilos: position: "relative", position: "fixed" o position: "absolute".
     */
    fill: prop_types_1.default.bool,
    /**
     * Establece cómo se debe redimensionar el contenido, para que se ajuste a su contenedor.
     */
    objectFit: prop_types_1.default.oneOf([
        "fill",
        "contain",
        "cover",
        "none",
        "scale-down",
    ]),
    /**
     * Especifica la alineación del contenido del elemento dentro del elemento padre.
     */
    objectPosition: prop_types_1.default.string,
    /**
     * Clase para añadirle estilos extras al icono.
     */
    className: prop_types_1.default.string,
    /**
     * Para quitar loading-lazy.
     */
    priority: prop_types_1.default.bool,
    /**
     * Objeto para la customización del icono en dev.
     */
    custoObjectInfo: prop_types_1.default.shape({
        componentId: prop_types_1.default.string,
        componentInstance: prop_types_1.default.string,
        editFunction: prop_types_1.default.func,
    }),
    cyData: prop_types_1.default.string,
};
Imagen.defaultProps = {
    fill: false,
    custoObjectInfo: null,
    priority: false,
    className: "",
    cyData: "",
};
exports.default = Imagen;
//# sourceMappingURL=index.js.map